import { getParentGraphStep } from './getParentGraphStep.js';

export const getAllParentGraphSteps = (stepId, graph, parents = []) => {
  const parentStep = getParentGraphStep(stepId, graph);

  if (!parentStep) {
    return parents;
  }

  if (parents.some((p) => p.id === parentStep.id)) {
    console.log('Circular reference in getParentStepIds. Returning.');
    return parents;
  }

  if (parentStep.relation !== 'exit') {
    parents.push(parentStep);
  }

  return getAllParentGraphSteps(parentStep.id, graph, parents);
};
